module.exports = __webpack_public_path__ + "static/logo-88e882064f66d40e640dc3f617e5ac5f.png";